import React from 'react';

export const SlackLogo = ({ className = "w-6 h-6" }) => (
    <svg className={className} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path 
            d="M9.879 10.995l1.035 3.085 3.205-1.074-1.035-3.074-3.205 1.063zm-4.017 4.75l3.195-1.068-1.035-3.076-3.195 1.069 1.035 3.075zm8.238 2.643l3.195-1.068-1.035-3.076-3.195 1.069 1.035 3.075zm1.454-4.323l3.195-1.068-1.035-3.076-3.195 1.069 1.035 3.075zm-6.97-3.145l3.195-1.068-1.035-3.076-3.195 1.069 1.035 3.075zm8.238 2.643l3.195-1.068-1.035-3.076-3.195 1.069 1.035 3.075zM20.413 16.5l1.035-3.075-3.195 1.069 1.035 3.076 1.125-.37zM9.37 19.026l1.035-3.075-3.195 1.069 1.035 3.076 1.125-.37z" 
            fill="#E01E5A"
        />
        <path 
            d="M14.966 13.403l-1.035-3.079-3.205 1.074 1.035 3.074 3.205-1.069z" 
            fill="#36C5F0"
        />
        <path 
            d="M10.954 8.657l-1.035-3.079-3.205 1.074 1.035 3.074 3.205-1.069z" 
            fill="#2EB67D"
        />
        <path 
            d="M6.942 3.911l-1.035-3.079-3.205 1.074 1.035 3.074 3.205-1.069z" 
            fill="#ECB22E"
        />
    </svg>
); 